import Vue, { CreateElement, RenderContext, VNode } from "vue";
import { Transaction } from "@scrile/api-provider/dist/api/TransactionProvider";
import { timeAgo } from "@/lib/time";
import FormatMoney from "@/components/FormatMoney";

interface Props {
  transaction: Transaction;
}

export default Vue.extend({
  functional: true,
  name: "TransactionMoneyDate",
  props: { transaction: { type: Object } },
  render(h: CreateElement, ctx: RenderContext<Props>): VNode {
    const date = timeAgo(ctx.props.transaction.time);
    const isPositive = ctx.props.transaction.amount > 0;
    return h(
      "div",
      {
        class: ["transaction-item__money-date", ctx.data.class, ctx.data.staticClass],
        style: [ctx.data.style, ctx.data.staticStyle],
        directives: ctx.data.directives,
        on: ctx.listeners,
      },
      [
        h(
          FormatMoney,
          {
            class: ["transaction-item__amount caption", { __positive: isPositive }],
            props: { cost: ctx.props.transaction.amount },
          },
          []
        ),
        h("div", { class: "transaction-item__date" }, [date]),
      ]
    );
  },
});
